/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EnquadramentoResponsavelCriteriaDto } from '../models/enquadramento-responsavel-criteria-dto';
import { EnquadramentoResponsavelDto } from '../models/enquadramento-responsavel-dto';
import { EnquadramentoResponsavelFormDto } from '../models/enquadramento-responsavel-form-dto';
import { EnquadramentoResponsavelPageDto } from '../models/enquadramento-responsavel-page-dto';


/**
 * Enquadramentos Entidade Responsável
 */
@Injectable({
  providedIn: 'root',
})
export class EnquadramentoResponsavelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getResponsaveisTransferencia
   */
  static readonly GetResponsaveisTransferenciaPath = '/enquadramentos-responsavel';

  /**
   * Pesquisar Responsáveis Transferência.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResponsaveisTransferencia()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResponsaveisTransferencia$Response(params?: {
    criteria?: EnquadramentoResponsavelCriteriaDto;
  }): Observable<StrictHttpResponse<EnquadramentoResponsavelPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoResponsavelService.GetResponsaveisTransferenciaPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoResponsavelPageDto>;
      })
    );
  }

  /**
   * Pesquisar Responsáveis Transferência.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getResponsaveisTransferencia$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResponsaveisTransferencia(params?: {
    criteria?: EnquadramentoResponsavelCriteriaDto;
  }): Observable<EnquadramentoResponsavelPageDto> {

    return this.getResponsaveisTransferencia$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoResponsavelPageDto>) => r.body as EnquadramentoResponsavelPageDto)
    );
  }

  /**
   * Path part for operation submeterEnquadramentoResponsavel
   */
  static readonly SubmeterEnquadramentoResponsavelPath = '/enquadramentos-responsavel';

  /**
   * Submeter Pedido de Enquadramento de Entidade Responsável.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterEnquadramentoResponsavel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterEnquadramentoResponsavel$Response(params?: {
    body?: EnquadramentoResponsavelFormDto
  }): Observable<StrictHttpResponse<EnquadramentoResponsavelDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoResponsavelService.SubmeterEnquadramentoResponsavelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoResponsavelDto>;
      })
    );
  }

  /**
   * Submeter Pedido de Enquadramento de Entidade Responsável.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterEnquadramentoResponsavel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterEnquadramentoResponsavel(params?: {
    body?: EnquadramentoResponsavelFormDto
  }): Observable<EnquadramentoResponsavelDto> {

    return this.submeterEnquadramentoResponsavel$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoResponsavelDto>) => r.body as EnquadramentoResponsavelDto)
    );
  }

  /**
   * Path part for operation getEnquadramentoResponsavel
   */
  static readonly GetEnquadramentoResponsavelPath = '/enquadramentos-responsavel/{id}';

  /**
   * Pesquisar Responsáveis Transferência por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnquadramentoResponsavel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentoResponsavel$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EnquadramentoResponsavelDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoResponsavelService.GetEnquadramentoResponsavelPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoResponsavelDto>;
      })
    );
  }

  /**
   * Pesquisar Responsáveis Transferência por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEnquadramentoResponsavel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentoResponsavel(params: {
    id: number;
  }): Observable<EnquadramentoResponsavelDto> {

    return this.getEnquadramentoResponsavel$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoResponsavelDto>) => r.body as EnquadramentoResponsavelDto)
    );
  }

}
